import { useCallback, useMemo } from 'react';
import { useRxData } from 'rxdb-hooks';

import { EL, MI, SH, ST } from '../../utilities/constants';
import { Discipline } from '../../utilities/enums';
import { RxdbCollectionName } from '../rxdbCollectionName';
import type { ConditionRating, ConditionRatingCollection } from './conditionRating.types';

const useConditionRating = (disciplineId: number) => {
  const validOptions = useMemo(() => {
    if (disciplineId === Discipline.Structural) return ST.rating;
    if (disciplineId === Discipline.Mechanical) return MI.rating;
    if (disciplineId === Discipline.Shaft) return SH.rating;
    if (disciplineId === Discipline.Electrical) return EL.rating;
    return [];
  }, [disciplineId]);

  const getConditionRatingQuery = useCallback(
    (collection: ConditionRatingCollection) => {
      return collection?.find({ selector: { sort: { $in: validOptions } } });
    },
    [validOptions],
  );

  const { result: conditionRatingListData } = useRxData<ConditionRating>(
    RxdbCollectionName.CONDITION_RATING,
    getConditionRatingQuery,
    { json: true },
  );

  return { conditionRatingListData };
};

export default useConditionRating;
